<template>
<div class="chapter">
<div class="inner_page">
<p class="C702"><span id="page_1">C</span>HAPTER ONE</p>
<p class="P75"><span id="id_19">H</span>ISTORY IN THE MAKING</p>
<p class="P58"><img alt="image" class="Image3" src="html/images/p0001-1.gif"/></p>
<p class="C736"><em>The author with Dr. King at a press conference announcing the settlement agreement with the City of Birmingham ending segregation of downtown department stores, lunch counters, and public facilities</em>.</p>
<p class="C736"><em>Photo: Ernst Haas/Getty Images</em></p>
<p class="break1"> </p>
<p class="C738"><em><span id="page_2">They</span> cried, and their cry came up unto God by reason of their bondage</em>.</p>
<p class="C668a">—Exodus 2:23</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_CHAPTER.vue?0e31e901